var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 12.0003C17.3333 15.222 14.7216 17.8337 11.5 17.8337C8.27829 17.8337 5.66663 15.222 5.66663 12.0003C5.66663 8.77866 8.27829 6.16699 11.5 6.16699C14.7216 6.16699 17.3333 8.77866 17.3333 12.0003ZM10.8252 15.089L15.1532 10.7611C15.3001 10.6141 15.3001 10.3758 15.1532 10.2288L14.621 9.69663C14.474 9.54964 14.2357 9.54964 14.0887 9.69663L10.5591 13.2262L8.91121 11.5783C8.76424 11.4314 8.52595 11.4314 8.37896 11.5783L7.84674 12.1105C7.69978 12.2575 7.69978 12.4958 7.84674 12.6428L10.293 15.089C10.44 15.236 10.6782 15.236 10.8252 15.089Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconCircle);
export default __webpack_public_path__ + "static/media/check-icon-circle.293225a1808a4fe064e3f9ce6f39d7e6.svg";
export { ForwardRef as ReactComponent };